import React, { FC, useEffect, useState } from 'react'
import { createUseStyles } from 'react-jss'
import { Typography } from '../../ui/Typography/Typography'
import { Member } from '../../../models/Member'
import { colors } from '../../../theme/palette'
import { baseButton, sortPlaceholder } from '../../../theme/reuseables'
import { L } from '../../providers/Lokalise'
import { MemberOnUpdate, UpdateBatch } from '../../../models/UpdateBatch'
import { Overlay } from '../../ui/Sidebar'
import { formatDate } from '../../../utils/format'
import { Badge } from '../../ui/Badge/Badge'
import { Card, CardCell, CardMobile, Circle } from '../../ui/Card'
import breakpoints from '../../../theme/breakpoints'
import {
    DrawerContent,
    DrawerHeaderMemberInfo,
} from '../FormElements/DrawerHeader'
import { getUpdateDetails } from '../../../api/updates'
import { EditFill, PersonalInfo } from '../../../assets/icons'
import { getUpdateStatusLabel, getUpdateTypeLabel } from '../../../utils/utils'
import { CircleIcon } from '../../ui/Circle/Circle'
import { FormHeader } from '../../ui/FormElememts/FormHeader'
import { FormControl } from '../../ui/FormElememts/FormControl'

export const getLabel = (fieldName: string): string => {
    let label = fieldName
    switch (fieldName) {
        // OPDATERINGER_DETALJER_ARBEJDSSTED_LABEL
        case 'Arbejdsstednummer':
            label = L('OPDATERINGER_DETALJER_ARBEJDSSTED_LABEL')
            break
        // OPDATERINGER_DETALJER_PRIVAT-MOBIL_LABEL
        case 'PrivatMobil':
            label = L('OPDATERINGER_DETALJER_PRIVAT-MOBIL_LABEL')
            break
        // OPDATERINGER_DETALJER_TIMETAL_LABEL
        case 'Timetal':
            label = L('OPDATERINGER_DETALJER_TIMETAL_LABEL')
            break
        // OPDATERINGER_DETALJER_STILLING_LABEL
        case 'Stillingsnummer':
            label = L('OPDATERINGER_DETALJER_STILLING_LABEL')
            break
        // OPDATERINGER_DETALJER_TRTELEFON_LABEL
        case 'TRTelefon':
            label = L('OPDATERINGER_DETALJER_TRTELEFON_LABEL')
            break
        // OPDATERINGER_DETALJER_TRMAIL_LABEL
        case 'TREmail ':
            label = L('OPDATERINGER_DETALJER_TRMAIL_LABEL')
            break
        // OPDATERINGER_DETALJER_ARBEJDSMAIL_LABEL
        case 'ArbejdsEmail':
            label = L('OPDATERINGER_DETALJER_ARBEJDSMAIL_LABEL')
            break
        // OPDATERINGER_DETALJER_ARBEJDSTELEFON_LABEL
        case 'ArbejdsTelefon':
            label = L('OPDATERINGER_DETALJER_ARBEJDSTELEFON_LABEL')
            break
        // OPDATERINGER_DETALJER_PRIVAT-EMAIL_LABEL
        case 'PrivatEmail':
            label = L('OPDATERINGER_DETALJER_PRIVAT-EMAIL_LABEL')
            break
        // OPDATERINGER_DETALJER_PRIVAT-FASTNET-TELEFON_LABEL
        case 'PrivatFastnetTelefon':
            label = L('OPDATERINGER_DETALJER_PRIVAT-FASTNET-TELEFON_LABEL')
            break
        default:
            break
    }

    return label
}

interface EditProps {
    update: UpdateBatch
    gridTemplateColumns: string
    showUpdatedColumn?: boolean
}

const useStyles = createUseStyles({
    '@keyframes fadeIn': {
        from: {
            opacity: 0,
        },
        to: {
            opacity: 1,
        },
    },
    contentWrapper: {
        padding: '100px 20px 20px',
        overflow: 'auto',
        height: '100%',
        paddingBottom: '80px',
    },
    container: {
        padding: '0 1.5rem',
        [`@media (min-width: ${breakpoints.Desktop}px)`]: {
            '&': {
                padding: '0',
            },
        },
    },
    headerArea: {
        display: 'flex',
        padding: '.5rem 0',
        minHeight: '5rem',
    },
    headerAreaTop: {
        display: 'flex',
        padding: '1rem 0 .5rem',
        borderBottom: `1px solid ${colors.borderColor}`,
        marginBottom: '1rem',
    },
    topArea: {
        borderBottom: `1px solid ${colors.gray700}`,
        // TODO: remove this when this area has been developed.
        minHeight: '60px',
    },
    headerActions: {
        display: 'flex',
        flexGrow: 1,
        marginLeft: 'auto',
        justifyContent: 'flex-end',
        alignItems: 'flex-start',
        flexShrink: 0,
    },
    sendingEmailSettings: {
        display: 'flex',
        padding: '.5rem 1rem',
        minHeight: '5rem',
        width: '100%',
        backgroundColor: colors.green200,
        color: colors.black,
        justifyContent: 'space-between',
        alignItems: 'center',
        '& span': {
            fontWeight: 700,
        },
        animation: '.5s $fadeIn',
    },
    dialogButtonsContainer: {
        display: 'flex',
        width: '100%',
        justifyContent: 'space-around',
    },
    button: {
        ...baseButton,
        ...{
            cursor: 'pointer',
        },
    },
    modalButtons: {
        display: 'flex',
    },
    modalCheckbox: {
        display: 'flex',
        position: 'absolute',
        right: '20px',
        top: '20px',
    },
    iconWrapper: {
        position: 'relative',
    },
    content: {
        display: '-webkit-box',
        WebkitLineClamp: '2',
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    deleteButtons: {
        top: '0',
        right: '0',
        display: 'flex',
        zIndex: '1',
        position: 'absolute',
        flexWrap: 'wrap',
        transition: 'all .3s ease-in',
        justifyContent: 'end',
        width: '100%',
        height: '100%',
        alignItems: 'center',
        background: 'rgba(255,255,255, .7)',
    },
    sortPlaceholder: {
        ...sortPlaceholder,
    },
    sidebarArea: {
        marginBottom: '20px',
    },
    circleIcon: {
        width: '62px',
        height: '62px',
        borderRadius: '50%',
        border: `2px solid ${colors.white}`,
        backgroundColor: colors.blue300,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginRight: '1rem',
    },
    oldName: {
        textDecoration: 'line-through',
        display: 'block',
    },
})

export type RegistrationFormFields = {
    Titel: string
    Indhold: string
    ReferenceType: string
}

export type UpdateDetailsSidebarContentType = {
    memberId: number
    update: UpdateBatch
    isOpen: boolean
    updateDetails: any | undefined
}

const UpdateDetailsSidebarContent: FC<UpdateDetailsSidebarContentType> = ({
    memberId,
    update,
    updateDetails,
    isOpen,
}) => {
    const classes = useStyles()
    const [isFetching, setIsFetching] = useState(false)
    // const [updateDetails, setUpdateDetails] = useState<any | undefined>(
    //     undefined
    // )

    const renderDate = (dateString: string | null): string => {
        if (dateString === null) {
            return 'Ingen dato'
        }

        const date = new Date(dateString)
        const now = new Date()
        const nowYear = now.getFullYear()
        let isValid = false

        if (Object.prototype.toString.call(date) === '[object Date]') {
            if (!Number.isNaN(date.getTime())) {
                isValid = true
            }
        }

        if (
            !isValid ||
            nowYear - date.getFullYear() > 9 ||
            nowYear - date.getFullYear() < -9
        ) {
            return 'Ikke gyldig dato'
        }

        return formatDate(date)
    }

    const sortingArr = [
        'Arbejdsstednummer',
        'Stillingsnummer',
        'Timetal',
        'PrivatMobil',
        'PrivatFastnetTelefon',
        'PrivatEmail',
        'ArbejdsTelefon',
        'ArbejdsEmail',
    ]

    if (
        !updateDetails ||
        (updateDetails &&
            updateDetails.OpdateringFelter &&
            !updateDetails.OpdateringFelter.length)
    )
        return null

    return (
        <div style={{ margin: '40px 0 40px' }}>
            <FormHeader>
                <Typography
                    tag="h3"
                    size="M"
                    spacing=".2rem"
                    weight="bold"
                    color={colors.green500}
                >
                    {L('MINEOPDATERINGER_DETALJER_TITEL')}
                </Typography>
            </FormHeader>
            <Typography
                tag="hr"
                style={{
                    width: '100%',
                    border: 'none',
                    borderTop: '2px dashed rgba(0,0,0,0.2)',
                }}
            />
            {updateDetails ? (
                <>
                    {updateDetails.OpdateringFelter.sort(
                        (a, b) =>
                            sortingArr.indexOf(a.OpdateringFeltType) -
                            sortingArr.indexOf(b.OpdateringFeltType)
                    ).map((field) => {
                        if (
                            update.type === 'OpdaterMedlem' &&
                            field.OpdateringFeltType === 'Arbejdsstednummer'
                        ) {
                            return null
                        }
                        return (
                            <FormControl>
                                <Typography
                                    tag="p"
                                    size="S"
                                    weight="bold"
                                    style={{ marginBottom: '5px' }}
                                >
                                    {getLabel(field.OpdateringFeltType)}
                                </Typography>
                                <Typography tag="p" size="S">
                                    <span
                                        className={
                                            update.type === 'MedlemOphoert' &&
                                            classes.oldName
                                        }
                                    >
                                        {field.NyVaerdiNavn || ' '}
                                    </span>
                                    {update.type === 'OpdaterMedlem' ? (
                                        <span className={classes.oldName}>
                                            {field.GlVaerdiNavn || ' '}
                                        </span>
                                    ) : null}
                                </Typography>
                            </FormControl>
                        )
                    })}
                    <FormControl>
                        <Typography
                            tag="p"
                            size="S"
                            weight="bold"
                            style={{ marginBottom: '5px' }}
                        >
                            {L('MINEOPDATERINGER_DETALJER_ÆNDRES-PR_LABEL')}
                        </Typography>
                        <Typography tag="p" size="S">
                            {renderDate(
                                updateDetails.OpdateringType !== 'MedlemOphoert'
                                    ? updateDetails.FraDato
                                    : updateDetails.OphoertDato
                            )}
                        </Typography>
                    </FormControl>
                    {updateDetails.OevrigeOplysninger ? (
                        <FormControl>
                            <Typography
                                tag="p"
                                size="S"
                                weight="bold"
                                style={{ marginBottom: '5px' }}
                            >
                                {L(
                                    'MINEOPDATERINGER_DETALJER_ØVRIGE_OPL_LABEL'
                                )}
                            </Typography>
                            <Typography tag="p" size="S">
                                {updateDetails.OevrigeOplysninger}
                            </Typography>
                        </FormControl>
                    ) : null}
                </>
            ) : null}
        </div>
    )
}

type overlayProps = {
    update: UpdateBatch
    onHide?: (boolean: boolean) => void
    isOpen?: boolean
}

const castAsMember = (memberOnUpdate: MemberOnUpdate): Member => {
    const m = new Member()

    m.birthday = new Date(memberOnUpdate.birthday)
    m.memberId = memberOnUpdate.id
    m.fullName = memberOnUpdate.fullName

    return m
}

const DetailsOverlay = ({ update, onHide, isOpen }: overlayProps): any => {
    const [isFetching, setIsFetching] = useState(false)
    const [updateDetails, setUpdateDetails] = useState<any | undefined>(
        undefined
    )

    const workplace = updateDetails?.OpdateringFelter?.find(
        (place) => place.OpdateringFeltType === 'Arbejdsstednummer'
    )?.NyVaerdiNavn

    useEffect(() => {
        const fetch = async (): Promise<void> => {
            setIsFetching(true)
            try {
                const response2 = await getUpdateDetails(update.batchId)
                setUpdateDetails(response2.data)
                setIsFetching(false)
            } catch {
                setIsFetching(false)
            }

            setIsFetching(false)
        }

        if (!isFetching && !updateDetails && isOpen) {
            fetch()
        }
    }, [isFetching, update.batchId, updateDetails, isOpen])

    return (
        <Overlay
            isShowing={isOpen}
            hide={() => {
                if (onHide) {
                    onHide(false)
                }
            }}
        >
            <div>
                <DrawerHeaderMemberInfo member={castAsMember(update.member)} />
            </div>
            <DrawerContent>
                <Typography
                    tag="h2"
                    size="XL"
                    align="center"
                    weight="bold"
                    style={{ margin: '20px 0 10px' }}
                >
                    {getUpdateTypeLabel(update.type)}
                </Typography>
                {update.type === 'OpdaterOgTilfoejEksisterendeMedlem' && (
                    <Typography tag="h3" size="M" align="center">
                        <Typography tag="h3" size="M" align="center">
                            {update.member.fullName}
                        </Typography>
                    </Typography>
                )}
                {update.type === 'OpdaterMedlem' && (
                    <Typography tag="h3" size="M" align="center">
                        {`${update.member.fullName || ' '}, ${
                            workplace !== undefined ? workplace : ' '
                        }`}
                    </Typography>
                )}
                {update.type === 'MedlemOphoert' && (
                    <Typography tag="h3" size="M" align="center">
                        {update.member.fullName || ' '}
                    </Typography>
                )}
                <UpdateDetailsSidebarContent
                    update={update}
                    memberId={update.member.id}
                    isOpen={isOpen}
                    updateDetails={updateDetails}
                />
                <div style={{ marginTop: '40px' }}>
                    <FormHeader>
                        <Typography
                            tag="h3"
                            size="M"
                            spacing=".2rem"
                            weight="bold"
                            color={colors.green500}
                        >
                            {L('MINEOPDATERINGER_DETALJER_INFO_LABEL')}
                        </Typography>
                    </FormHeader>
                    <Typography
                        tag="hr"
                        style={{
                            border: 'none',
                            width: '100%',
                            borderTop: '2px dashed rgba(0,0,0,0.2)',
                        }}
                    />
                    <FormControl>
                        <Typography
                            tag="p"
                            size="S"
                            weight="bold"
                            style={{ marginBottom: '5px' }}
                        >
                            {L('MINEOPDATERINGER_DETALJER_INDSENDT-AF')}
                        </Typography>
                        <Typography tag="p" size="S">
                            {update.profile.fullName}
                        </Typography>
                    </FormControl>
                    {/* <FormControl>
                    <Typography
                        tag="p"
                        size="S"
                        weight="bold"
                        style={{ marginBottom: '5px' }}
                    >
                        Fødseldag
                    </Typography>
                    <Typography tag="p" size="S">
                        {formatDate(new Date(update.member.birthday))}
                    </Typography>
                </FormControl> */}

                    <FormControl>
                        <Typography
                            tag="p"
                            size="S"
                            weight="bold"
                            style={{ marginBottom: '5px' }}
                        >
                            {L('MINEOPDATERINGER_DETALJER_INDSENDT-DATO')}
                        </Typography>
                        <Typography tag="p" size="S">
                            {formatDate(new Date(update.created))}
                        </Typography>
                    </FormControl>
                    {/* <FormControl>
                    <Typography
                        tag="p"
                        size="S"
                        weight="bold"
                        style={{ marginBottom: '5px' }}
                    >
                        {L('MINEOPDATERINGER_DETALJER_MEDLEM')}
                    </Typography>
                    <Typography tag="p" size="S">
                        {update.member.fullName}
                    </Typography>
                </FormControl> */}

                    <FormControl>
                        <Typography
                            tag="p"
                            size="S"
                            weight="bold"
                            style={{ marginBottom: '5px' }}
                        >
                            {L('MINEOPDATERINGER_DETALJER_INDSENDT-TIL_LABEL')}
                        </Typography>
                        <Typography tag="p" size="S">
                            {update.member.department.name}
                        </Typography>
                    </FormControl>

                    <FormControl>
                        <Typography
                            tag="p"
                            size="S"
                            weight="bold"
                            style={{ marginBottom: '5px' }}
                        >
                            {L('MINEOPDATERINGER_DETALJER_STATUS')}
                        </Typography>
                        <Typography tag="p" size="S">
                            {getUpdateStatusLabel(update.status)}
                        </Typography>
                    </FormControl>
                    {update.status === 'FaerdigBehandlet' ? (
                        <FormControl>
                            <Typography
                                tag="p"
                                size="S"
                                weight="bold"
                                style={{ marginBottom: '5px' }}
                            >
                                Opdateret
                            </Typography>
                            <Typography tag="p" size="S">
                                {formatDate(new Date(update.updated))}
                            </Typography>
                        </FormControl>
                    ) : null}
                </div>
            </DrawerContent>
        </Overlay>
    )
}

export const UpdateDetails: FC<EditProps> = ({
    update,
    gridTemplateColumns,
    showUpdatedColumn,
}) => {
    const classes = useStyles()
    const [isOpen, setIsOpen] = useState(false)

    if (update.type === 'OpdaterTR_FTR') {
        return null
    }

    return (
        <>
            <CardMobile
                gridTemplateColumns="auto"
                onClick={() => setIsOpen(!isOpen)}
                key={update.batchId + new Date().toDateString()}
            >
                <CardCell>
                    <Typography
                        tag="p"
                        size="S"
                        weight="bold"
                        style={{ marginBottom: '5px' }}
                    >
                        {L('MINEOPDATERINGER_INDSENDT_KOLONNE_OVERSKRIFT')}
                    </Typography>
                    <Typography size="XS">
                        {formatDate(new Date(update.created))}
                    </Typography>
                </CardCell>
                <CardCell>
                    <Typography
                        tag="p"
                        size="S"
                        weight="bold"
                        style={{ marginBottom: '5px' }}
                    >
                        {L('MINEOPDATERINGER_MEDLEM_KOLONNE_OVERSKRIFT')}
                    </Typography>
                    <Typography size="XS">{update.member.fullName}</Typography>
                </CardCell>
                <CardCell>
                    <Typography
                        tag="p"
                        size="S"
                        weight="bold"
                        style={{ marginBottom: '5px' }}
                    >
                        {L('MINEOPDATERINGER_MEDLEM_KOLONNE_OVERSKRIFT')}
                    </Typography>
                    <Typography size="XS">
                        <span className={classes.content}>
                            {getUpdateTypeLabel(update.type)}
                        </span>
                    </Typography>
                </CardCell>
                <CardCell overflowHidden>
                    <Typography
                        tag="p"
                        size="S"
                        weight="bold"
                        style={{ marginBottom: '5px' }}
                    >
                        {L('MINEOPDATERINGER_INDSENDT-AF_KOLONNE_OVERSKRIFT')}
                    </Typography>
                    <Typography size="XS">
                        <span className={classes.content}>
                            {update.profile.fullName}
                        </span>
                    </Typography>
                </CardCell>
                {showUpdatedColumn ? (
                    <CardCell>
                        <Typography
                            tag="p"
                            size="S"
                            weight="bold"
                            style={{ marginBottom: '5px' }}
                        >
                            {L('MINEOPDATERINGER_OPDATERET_KOLONNE_OVERSKRIFT')}
                        </Typography>
                        <Typography size="XS">
                            {formatDate(new Date(update.updated))}
                        </Typography>
                    </CardCell>
                ) : null}
                <CardCell>
                    <Badge>
                        <Typography size="XS">
                            {getUpdateStatusLabel(update.status)}
                        </Typography>
                    </Badge>
                </CardCell>
            </CardMobile>
            <Card
                useHover
                key={update.batchId}
                gridTemplateColumns={gridTemplateColumns}
                onClick={() => {
                    setIsOpen(!isOpen)
                }}
            >
                <CardCell>
                    <Typography size="XS">
                        {formatDate(new Date(update.created))}
                    </Typography>
                </CardCell>
                <CardCell>
                    <Typography size="XS">{update.member.fullName}</Typography>
                </CardCell>
                <CardCell>
                    <Typography size="XS">
                        <span className={classes.content}>
                            {getUpdateTypeLabel(update.type)}
                        </span>
                    </Typography>
                </CardCell>
                <CardCell overflowHidden>
                    <Typography size="XS">
                        <span className={classes.content}>
                            {update.profile.fullName}
                        </span>
                    </Typography>
                </CardCell>
                {showUpdatedColumn ? (
                    <CardCell>
                        <Typography size="XS">
                            {formatDate(new Date(update.updated))}
                        </Typography>
                    </CardCell>
                ) : null}
                <CardCell>
                    <Badge>
                        <Typography size="XS">
                            {getUpdateStatusLabel(update.status)}
                        </Typography>
                    </Badge>
                </CardCell>
            </Card>
            <DetailsOverlay
                update={update}
                onHide={(boolean: boolean) => setIsOpen(boolean)}
                isOpen={isOpen}
            />
        </>
    )
}
